import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';

import { Box, Button, ButtonGroup, Heading, Modal, TextButton } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';

import { TRIGGER_LOCATIONS } from '../../../constants/ClickstreamConstants';

import ApplicationsCSEvents from '../../../model/ClickstreamEvent/ApplicationsCSEvents';

import AcceptApplicationsContentWithFields from '../../WizardModularListing/AcceptZillowApplications/components/AcceptApplicationsContentWithFields';

type Props = {
  onApplicationsModalClose: () => void;
  onApplicationsModalOpen: () => void;
  onSaveClick: () => void;
  isSaving: boolean;
  overrideTriggerLocation?:
    | typeof TRIGGER_LOCATIONS.OVERVIEW_TAB_ENABLE_APPS
    | typeof TRIGGER_LOCATIONS.APPS_TAB_ENABLE_APPS;
};

const ApplicationsModalWrapper = ({
  onApplicationsModalClose,
  onApplicationsModalOpen,
  onSaveClick,
  isSaving,
}: Props) => {
  const { user, currentProperty } = useSelector(
    (state) => ({
      user: state.user,
      currentProperty: state.properties.currentProperty,
    }),
    shallowEqual,
  );

  useEffect(() => {
    ApplicationsCSEvents.ClickApplicationsNextStep({
      currentProperty,
      user,
    });
  }, []);

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onApplicationsModalClose()}
      header={<Heading level={3}>Zillow applications</Heading>}
      size={{ base: 'fullScreen', md: 'md' }}
      footer={
        <ButtonGroup aria-label="Actions">
          <TextButton onClick={onApplicationsModalClose}>Cancel</TextButton>

          <Button tone="brand" emphasis="filled" onClick={onSaveClick} loading={isSaving}>
            Save
          </Button>
        </ButtonGroup>
      }
      body={
        <Box css={{ padding: '600' }}>
          <AcceptApplicationsContentWithFields triggerLocation={TRIGGER_LOCATIONS.PROPERTY_OVERVIEW} />
        </Box>
      }
    />
  );
};

export default ApplicationsModalWrapper;
